import QuestionnaireForm from '../Common/QuestionnaireForm';
import * as Survey from "survey-react";
import { putFormDataForCode } from '../../services/dataService';

class QuestionnaireFormCodeEntry extends QuestionnaireForm {

    constructor(props) {
        super(props);
        this.currentInstanceId = 0;
    }

   
    componentDidUpdate(prevProps) {

    if(this.props.directLoadedForm !== prevProps.directLoadedForm)
            this.populateDirectLoadedData();
    }

    populateDirectLoadedData = async () => {
        this.clearIntervalIfNecessary();


         this.model = new Survey.Model(this.props.directLoadedForm.formInfo.form);
                
        this.setFormData(this.props.directLoadedForm.formInfo);
        this.currentInstanceId = this.props.directLoadedForm.instanceId;
                        
        this.setState({ loading: false, isComplete: false });

    };

    saveDataToOverride= async (completed) =>{
        return await putFormDataForCode({ instanceId: this.currentInstanceId, completed: completed, responseCollection: this.model.data,
            lastUpdatedByUserId: this.instanceInfo.lastUpdatedByUserId, lastUpdated: this.instanceInfo.lastUpdated, 
            key1: this.props.key1, key2: this.props.key2 });  

    }

}
export default QuestionnaireFormCodeEntry;